const styles = ({ BREAKPOINTS }) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  pupilName: {
    textAlign: 'center',
    margin: '0'
  },
  navContianer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    left: '0',
    bottom: '0',
    width: '100%'
  },
  backToPupils: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      top: '10px',
      left: '10px'
    }
  }
})

export default styles
